export default __webpack_public_path__ + "static/media/Punto_12_Finocchietti_FRA_Def.ea64b158.aac";